<template>
  <div class="flex mb-20">
    <!--<sound-wave class="absolute w-full top-28 lg:top-0 z-0 opacity-40"></sound-wave>-->
    <div class="w-11/12 lg:w-1/2 mx-auto z-10 relative mt-48">
      <div class="flex items-center text-white text-lg font-sans-serif mx-auto z-10 mb-10">
        <router-link to="/masterclasses" class="transform hover:scale-105 transition duration-500">
          Masterclasses
        </router-link>
        <span class="px-1">/</span>
        <router-link v-if="masterclass.teacher"
          :to="isMasterclassTeacher ? '/teacher-dashboard' : '/teachers/'+masterclass.teacher.id">
          {{ masterclass.teacher.name }}
        </router-link>
      </div>
      <div class="flex justify-between items-center w-full">
        <div class="flex items-baseline w-full justify-start">
          <h1 class="text-white text-lg lg:text-3xl font-bold mr-10" v-if="masterclass.teacher">
            {{ masterclass.teacher.name }}
          </h1>
          <span class="text-base lg:text-xl text-orange-academy-400 font-extrabold font-sans-serif">
            {{dayStart}}
          </span>
        </div>
        <div v-if="!isMasterclassTeacher">
          <button class="text-white bg-orange-academy-300 px-1 py-3 rounded w-20 md:w-40
          hover:text-orange-academy-300 hover:bg-white border border-orange-academy-300 font-light
          md:font-black"
          v-if="!studentIsRegisteredAtTheMasterclass" @click="registerStudent">
            {{ $t('masterclass.registerMe') }}
          </button>
          <button class="text-black bg-white rounded shadow-lg p-1"
          v-else>
            {{ $t('masterclass.alreadySubscribed') }}
          </button>
        </div>
        <div v-else>
          <router-link class="text-white bg-orange-academy-300 px-5 py-1 rounded text-lg
          hover:text-orange-academy-300 hover:bg-white border border-orange-academy-300"
          :to="'/teacher-dashboard/masterclasses/'+masterclass.id">
            {{ $t('masterclass.edit') }}
          </router-link>
        </div>
      </div>

      <div class="shape mt-20">
        <div v-if="masterclass.teacher" class="w-full">
          <img :src="masterclass.teacher.urlProfilePhoto"
          class="object-cover w-full h-80 md-image">
        </div>
        <div class="font-sans-serif">
          <p class="bg-orange-academy-400 bg-opacity-75 text-white px-10 py-5">
            {{ masterclass.description }}
          </p>
          <div class="bg-white bg-opacity-50 px-3 lg:px-10 pt-5 pb-14 text-white">
            <div class="bg-white h-10 flex flex-col md:flex-row items-center w-auto
            rounded-md shadow my-3 justify-between px-10">
              <p class="flex font-sans-serif text-grey-academy-300">
                <img class="w-6 pr-2" src="../images/money.svg">
                <span>{{$t('masterclass.price')}}:</span>
                <span v-if="masterclass.price" class="pl-2">{{masterclass.price}}</span>
                <span v-else class="pl-2"> {{ $t('masterclass.free') }} </span>
              </p>
              <p class="flex font-sans-serif text-grey-academy-300">
                <img class="w-6 pr-2" src="../images/user.svg">
                <span>{{$t('masterclass.places')}}:</span>
                <span class="pl-2" v-if="masterclass.max_participants">
                  {{ masterclass.freePlaces}}
                </span>
                <span v-else class="pl-2"> {{ $t('masterclass.unlimit') }} </span>
              </p>
            </div>
            <span class="text-2xl font-medium">{{ $t('masterclass.program') }}</span>
            <masterclass-date :masterclass="masterclass" class="text-xl text-left" />
          </div>
        </div>
      </div>

    </div>

    <modal resizable name="register-to-masterclass" height="auto" :adaptive="true">
      <masterclass-registration :masterclass="masterclass" @updated-subscription="getMasterclass" />
    </modal>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import axios from 'axios';
import { mapGetters } from 'vuex';
import MasterclassDate from '../components/masterclasses/MasterclassDate.vue';
import MasterclassRegistration from '../components/modals/MasterclassRegistration.vue';
// import SoundWave from '../components/graphics/SoundWave.vue';

export default {

  data() {
    return {
      masterclass: {},
    };
  },

  components: {
    MasterclassDate,
    MasterclassRegistration,
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
    }),

    dayStart() {
      const date = this.masterclass.day ? dayjs.tz(`${this.masterclass.day} ${this.masterclass.start}`, 'UTC') : '';
      return dayjs(date).tz(this.choosenTimezone).format('LL');
    },

    isMasterclassTeacher() {
      if (this.authenticated && this.user.teacher
       && this.masterclass.teacher_id === this.user.teacher.id) {
        return true;
      }
      return false;
    },

    studentIsRegisteredAtTheMasterclass() {
      if (this.user && this.masterclass.students && this.masterclass.students.find(
        (student) => student.id === this.user.student.id,
      )) {
        return true;
      }
      return false;
    },
  },

  created() {
    this.getMasterclass();
  },

  methods: {
    getMasterclass() {
      axios.get(`/api/masterclasses/${this.$route.params.id}`).then(({ data }) => {
        this.masterclass = data;
      }).catch(() => {
        this.createNotification('error', this.$t('notifications.errorReload'));
      });
    },

    registerStudent() {
      if (this.authenticated) {
        this.$modal.show('register-to-masterclass');
        return;
      }
      this.$router.push(`/signin?redirect=${this.$route.fullPath}`);
    },
  },
};
</script>

<style scoped>
  .shape{
   box-shadow: 3.5em -3.2em black;
 }
  .shadow{
    --tw-shadow: 2px 3px 0px 0px rgba(75, 73, 73, 0.842), 2px 3px 4px 2px rgba(75, 75, 75, 0.726);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000),
    var(--tw-shadow);
  }
</style>
